import React from 'react'
import { Button, FormControl } from 'react-bootstrap'
// import { Typeahead } from 'react-bootstrap-typeahead'

const File = (props) => {
  let { categories, file, removeFile, handleFileUpload } = props
  let category = null

  if (file.hasOwnProperty('category')) {
    file = file.file
    category = file.category
  }

  return (
    <tr className="file-row">
      <td>
        <Button
          bsStyle="danger"
          onClick={removeFile}
        >
          Remove
        </Button>
      </td>
      <td>
        <span>
          {file.name.length <= 30 ?
            file.name
            :
            `${file.name.slice(0, 30)}...`
          }
        </span>
      </td>
      {category === null || !categories ?
        null
        :
        <td>
          <FormControl
            type="text"
            placeholder="Enter category"
            value={category}
            onChange={props.handleCategoryUpdate}
          />
          {/* <Typeahead
            id='fileCategoryTypeahead'
            clearButton
            labelKey="name"
            placeholder="Enter category"
            allowNew
            selected={category}
            options={categories}
            onChange={props.handleCategoryUpdate}
          /> */}
        </td>
      }
      { handleFileUpload ?
        <td>
          {handleFileUpload ?
            <Button
              bsStyle="primary"
              onClick={handleFileUpload}
            >
              Upload
            </Button>
            :
            null
          }
        </td>
        :
        null
      }
    </tr>
  )
}

export default File



// WEBPACK FOOTER //
// ./src/reuseable-components/file-uploading/File.js